import React from 'react'
import styled from '@nobia/zeus-components/lib/styled'

import GlobalStyles from '../styles/global'
import HomePage from '../pages/home/HomePage'
import ContextProvider from './contextProvider'

const Wrapper = styled.div`
  text-align: center;
`

const App = () => (
  <ContextProvider>
    <Wrapper>
      <GlobalStyles />
      <HomePage />
    </Wrapper>
  </ContextProvider>
)
export default App
